export default __webpack_public_path__ + "static/banner-what-to-look-for-when-choosing-your-financial-institution-2305554b8b48f6996bb8bb46ddaefd0c.jpg";